import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { IbanXSBanksRecipientsPivot as IbanXSBanksRecipientsPivotComponent } from "ui/organizms/OpenBanking";

const IbanXSBanksRecipientsPivot = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Open Banking | Iban XS Banks Recipients Pivot'
    >
        <IbanXSBanksRecipientsPivotComponent />
    </Screen>

);

export default memo(IbanXSBanksRecipientsPivot);
